import { useLayoutEffect } from "react";
import { FAB_SCREEN_EDGE_PX } from "@/shared/ui/appHeader/mobileBottomNav";

/** Set while a table pagination bar is mounted. Desktop uses it to lift the assistant button. */
export const TABLE_FOOTER_CLEARANCE_VAR = "--table-footer-clearance";

let mountedFooters = 0;

/** Publishes the footer height while at least one pagination bar is mounted. */
export function retainTableFooterClearance(heightPx: number): () => void {
  mountedFooters += 1;
  document.documentElement.style.setProperty(TABLE_FOOTER_CLEARANCE_VAR, `${heightPx}px`);
  return () => {
    mountedFooters = Math.max(0, mountedFooters - 1);
    if (mountedFooters === 0) {
      document.documentElement.style.removeProperty(TABLE_FOOTER_CLEARANCE_VAR);
    }
  };
}

/** Desktop assistant bottom: the usual corner, raised by the footer while one is mounted. */
export function desktopFabBottom(edgePx: number = FAB_SCREEN_EDGE_PX): string {
  return `calc(var(${TABLE_FOOTER_CLEARANCE_VAR}, 0px) + ${edgePx}px)`;
}

/** Keeps the desktop assistant button above this footer. Hidden copies pass `enabled: false`. */
export function useTableFooterClearance(enabled: boolean, heightPx: number): void {
  useLayoutEffect(() => {
    if (!enabled) {
      return;
    }
    return retainTableFooterClearance(heightPx);
  }, [enabled, heightPx]);
}
